//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import { confirmationDialogFactory } from 'common/components/core/dialog/ConfirmationDialog';
import { translate } from 'react-i18next';

import { dashboardColors } from 'common/enums/ColorEnum';
import defaultTheme from './BulkEditConfirmationDialog.scss';

const ConfirmationInnerContent = ({
    t,
    entityI18nId,
    theme,
    selectionCount
}) => {
    return (
        <span className={theme.content}>
            {t('entityManagement:bulkEditConfirmationDialog.message', {
                count: selectionCount,
                entity: t(entityI18nId, { count: selectionCount })
            })}
        </span>
    );
};

export const ConfirmationDialog = confirmationDialogFactory({
    InnerContent: ConfirmationInnerContent
});

type Props = {
    theme: Object,
    t: (string, ?Object) => string,
    selectionCount: number,
    entityI18nId: string,
    onAccept: () => void,
    onCancel: () => void
};

class BulkEditConfirmationDialog extends React.PureComponent<Props> {
    onAccept = () => {
        this.props.onAccept();
    };

    render() {
        const { selectionCount, onCancel, entityI18nId, theme, t } = this.props;
        const title = t('bulkEditConfirmationDialog.title', {
            count: selectionCount,
            entity: t(entityI18nId, { count: selectionCount })
        });
        return (
            <ConfirmationDialog
                t={t}
                theme={theme}
                title={title}
                onAccept={this.onAccept}
                onCancel={onCancel}
                acceptActionLabel={t('bulkEditConfirmationDialog.positiveCta')}
                acceptActionColor={dashboardColors.coolGreen.name}
                active
                selectionCount={selectionCount}
                entityI18nId={entityI18nId}
            />
        );
    }
}

const ThemedBulkEditConfirmationDialog = themr(
    'BulkEditConfirmationDialog',
    defaultTheme
)(translate('entityManagement')(BulkEditConfirmationDialog));
export { ThemedBulkEditConfirmationDialog as BulkEditConfirmationDialog };
export default ThemedBulkEditConfirmationDialog;
